declare var angular: any;
import * as _ from 'underscore';

angular.module('LexiconControllers')

  .directive("cfClickLexicon", ['lexicon', '$timeout', 'EXAM', function(lexicon, $timeout, EXAM) {
    return {
      restrict: 'A',

      scope: {
        'finished': '='
      },

      link: function(scope, element, attrs) {
        if (!(EXAM === 'lerobert' || EXAM === 'delf')) {
          var addClass = function(newVal) {
            if (newVal) {
              var spans = element[0].getElementsByTagName('span');
              for (var i = spans.length - 1; i >= 0; i--) {
                if(!spans[i].children.length && !spans[i].classList.length)
                  spans[i].className = 'lexicon-word';
              }

            }
          };

          $timeout(function() {
            var text = element.html();
            text = text.replace(/&ndash;/g,'–').replace(/&rsquo;/g,'\'').replace(/&lt;/g,'<').replace(/&nbsp;/g,' ').replace(/&gt;/g,'>').replace(/&amp;/g,'&');
            var span = '<span>$&</span>';
            element.html(text.replace(/(\w+)(?=[^>]*(<|$))/g, span));

            addClass(scope.finished);
          });

          element.on('click', function(event) {
            // unprevent click due to classname for CGS Style
            if (scope.finished && (event.target.className !== 'normal')) {
              lexicon.showWordBottom(event.target.innerHTML);
            }
          });

          scope.$watch('finished', addClass);
        }
      }
    };
  }
  ])

  .directive('cfQuote', function() {
    return {
      restrict: 'E',
      scope: {
        quotes: '=',
      },
      replace: true,
      template: '<blockquote>\
              <div class="text">&nbsp;{{quote.text}}&nbsp;</div>\
              <div class="author">{{quote.author}}</div>\
              </blockquote>',
      controller: ["$scope", function($scope) {
        $scope.quote = $scope.quotes[_.random(0, $scope.quotes.length-1)];
      }]
    };
  })


  .directive('cfLexiconPart', function() {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        meanings: '=',
      },
      template: '<p>{{parts | join:", "}}</p>',
      controller: ["$scope", function($scope) {
        $scope.parts = _.unique(
            _.map(
              $scope.meanings,
              function (meaning: any) {return meaning.part_of_speech;}
            )
          );
      }]
    };
  });
